import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface AutocallBarrierLevelFormFieldProps {}

export const AutocallBarrierLevelFormField: React.FC<AutocallBarrierLevelFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ autocall_barrier_level: number }>()

  return (
    <FormField
      name="autocall_barrier_level"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Autocall Barrier Level</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput {...register('autocall_barrier_level')} />
          </FormItem>
        )
      }}
    />
  )
}
